import React from "react";
import { useTranslation } from "react-i18next";

/** No in-page action here — the tap already happened on the driver's phone. `useReceiptData`'s own
 * polling is what moves this to SUCCESS/FAILURE once the driver's confirm request lands. */
const TapPaymentPendingCard: React.FC = () => {
  const { t } = useTranslation("paymentPage");

  return (
    <div className="bg-white min-h-screen flex flex-col items-center justify-center px-6">
      <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mb-6" />
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          {t("tapPaymentPendingTitle")}
        </h2>
        <p className="text-gray-600 text-lg leading-relaxed max-w-sm">
          {t("tapPaymentPendingBody")}
        </p>
      </div>
    </div>
  );
};

export default TapPaymentPendingCard;
